import { useDispatch } from 'react-redux';

import { fetchInquiryTemplateAndVersion } from 'dashboard/apps/InquiryTemplateEditor/utils/inquiry-template-version';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { InquiryTemplateVersion } from 'dashboard/models/inquiry-template-version';
import { showMessage } from 'dashboard/redux/actions/messages';
import useApiCallback from 'lib/hooks/useApiCallback';
import useApiErrorHandler from 'lib/hooks/useApiErrorHandler';
import { isPermissionsError, permissionsErrorMessage } from 'lib/permissions-errors';

export default (): {
  handleLoadInquiryTemplateVersion: (
    inquiryTemplateVersionId: string,
  ) => Promise<InquiryTemplateVersion | null>;
  loadingInquiryTemplateVersion: boolean;
} => {
  const dispatch = useDispatch();

  const {
    loading: loadingInquiryTemplateVersion,
    error: handleLoadInquiryTemplateVersionError,
    callback: handleLoadInquiryTemplateVersion,
  } = useApiCallback(async (inquiryTemplateVersionId: string) => {
    const { inquiryTemplateVersion } = await fetchInquiryTemplateAndVersion({
      inquiryTemplateVersionId,
    });
    return inquiryTemplateVersion;
  }, []);

  useApiErrorHandler({
    error: handleLoadInquiryTemplateVersionError,
    onError: (error) => {
      if (isPermissionsError(error)) {
        dispatch(showMessage(permissionsErrorMessage(error), MessageType.Failure));
      }

      dispatch(showMessage('Failed to load inquiry template information', MessageType.Failure));
    },
    onNetworkError: () =>
      dispatch(
        showMessage('We are experiencing network issues. Please try again.', MessageType.Failure),
      ),
  });

  return {
    handleLoadInquiryTemplateVersion,
    loadingInquiryTemplateVersion,
  };
};
